import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["sidebar", "left", "handle"];

    connect() {
        this.resizing = false;
        this.lastDownX = 0;
        this.container = this.element;
        
        // Set up resize handle if available
        if (this.hasHandleTarget) {
            this.handle = this.handleTarget;
            this.handle.addEventListener('mousedown', (event) => this.startResize(event));
        } else if (this.hasSidebarTarget) {
            // Fallback: use sidebar left edge
            this.sidebar = this.sidebarTarget;
            this.sidebar.addEventListener('mousedown', (event) => this.startResize(event));
        }
        
        document.addEventListener('mousemove', (event) => this.resize(event));
        document.addEventListener('mouseup', () => this.stopResize());
    }

    startResize(event) {
        event.preventDefault();
        this.resizing = true;
        this.lastDownX = event.clientX;
        
        // Get initial widths
        if (this.hasLeftTarget && this.hasSidebarTarget) {
            this.leftWidth = this.leftTarget.offsetWidth;
            this.sidebarWidth = this.sidebarTarget.offsetWidth;
        }
        
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }

    resize(event) {
        if (!this.resizing) return;
        
        // Use requestAnimationFrame for smooth rendering
        window.requestAnimationFrame(() => {
            if (!this.hasLeftTarget || !this.hasSidebarTarget) return;
            
            const deltaX = event.clientX - this.lastDownX;
            const containerWidth = this.container.offsetWidth;
            
            // Calculate new widths
            let newLeftWidth = this.leftWidth + deltaX;
            let newSidebarWidth = this.sidebarWidth - deltaX;
            
            // Minimum widths
            const minWidth = 400;
            
            // Ensure minimum widths
            if (newLeftWidth < minWidth) {
                newLeftWidth = minWidth;
                newSidebarWidth = containerWidth - minWidth;
            }
            if (newSidebarWidth < minWidth) {
                newSidebarWidth = minWidth;
                newLeftWidth = containerWidth - minWidth;
            }
            
            // Apply new widths
            this.leftTarget.style.width = `${newLeftWidth}px`;
            this.sidebarTarget.style.width = `${newSidebarWidth}px`;
        });
    }

    stopResize() {
        if (this.resizing) {
            this.resizing = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        }
    }
}